import { NgFor, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type SkeletonVariant =
  | 'table'
  | 'accordion'
  | 'cards'
  | 'card'
  | 'plan-card'
  | 'membership-detail'
  | 'dialog-details'
  | 'tree'
  | 'home-banner'
  | 'home-live-score'
  | 'home-events'
  | 'home-videos'
  | 'home-promotion'
  | 'banner'
  | 'block'
  | 'form';

const indexes = (count: number): number[] => Array.from({ length: Math.max(count, 0) }, (_, index) => index);

@Component({
  selector: 'stupa-skeleton-loader',
  standalone: true,
  imports: [NgFor, NgTemplateOutlet, TranslateModule],
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.h-100]': "variant() === 'block'",
    '[class.sk-plan-host]': "variant() === 'plan-card'",
  },
})
export class SkeletonLoaderComponent {
  readonly variant = input<SkeletonVariant>('table');
  readonly rows = input(5);
  readonly columns = input(5);
  readonly panels = input(4);
  readonly cards = input(3);
  readonly layout = input(1);

  readonly rowIndexes = computed(() => indexes(this.rows()));
  readonly columnIndexes = computed(() => indexes(this.columns()));
  readonly panelIndexes = computed(() => indexes(this.panels()));
  readonly cardIndexes = computed(() => indexes(this.cards()));
  readonly treeRounds = [indexes(4), indexes(2), indexes(1)];
  readonly homeCards = indexes(5);
  readonly promoBlocks = computed(() => indexes(this.layout() === 4 ? 4 : Math.max(this.layout() - 1, 1)));

  trackByIndex(index: number): number {
    return index;
  }
}
